export const categories = [
  {
    "catNo": "001",
    "catNm": "패션/뷰티",
    "upCatNo": "TOP",
    "sortOrd": "1",
    "childList": [
      {
        "catNo": "001005",
        "catNm": "뷰티",
        "upCatNo": "001",
        "sortOrd": "1",
        "childList": null
      },
      {
        "catNo": "001001",
        "catNm": "여성 의류",
        "upCatNo": "001",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "001002",
        "catNm": "남성 의류",
        "upCatNo": "001",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "001003",
        "catNm": "캐주얼 의류",
        "upCatNo": "001",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "001004",
        "catNm": "패션 잡화",
        "upCatNo": "001",
        "sortOrd": "99",
        "childList": null
      }
    ]
  },
  {
    "catNo": "002",
    "catNm": "식품/생활",
    "upCatNo": "TOP",
    "sortOrd": "2",
    "childList": [
      {
        "catNo": "002001",
        "catNm": "간편식/냉장/냉동",
        "upCatNo": "002",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "002002",
        "catNm": "생수/음료/커피/유제품",
        "upCatNo": "002",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "002003",
        "catNm": "건강식품",
        "upCatNo": "002",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "002004",
        "catNm": "식품",
        "upCatNo": "002",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "002005",
        "catNm": "화장지/생리대",
        "upCatNo": "002",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "002006",
        "catNm": "헤어/바디/구강/면도",
        "upCatNo": "002",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "002007",
        "catNm": "생활/주방",
        "upCatNo": "002",
        "sortOrd": "99",
        "childList": null
      }
    ]
  },
  {
    "catNo": "003",
    "catNm": "출산/유아",
    "upCatNo": "TOP",
    "sortOrd": "3",
    "childList": [
      {
        "catNo": "003001",
        "catNm": "유아 의류",
        "upCatNo": "003",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "003002",
        "catNm": "유아 잡화",
        "upCatNo": "003",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "003003",
        "catNm": "위생/건강/세제",
        "upCatNo": "003",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "003004",
        "catNm": "기저귀/물티슈",
        "upCatNo": "003",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "003005",
        "catNm": "분유/유아식품",
        "upCatNo": "003",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "003006",
        "catNm": "완구/교구/아동도서",
        "upCatNo": "003",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "003007",
        "catNm": "출산/유아",
        "upCatNo": "003",
        "sortOrd": "99",
        "childList": null
      }
    ]
  },
  {
    "catNo": "004",
    "catNm": "반려동물",
    "upCatNo": "TOP",
    "sortOrd": "4",
    "childList": [
      {
        "catNo": "004001",
        "catNm": "강아지 용품",
        "upCatNo": "004",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "004002",
        "catNm": "고양이 용품",
        "upCatNo": "004",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "004003",
        "catNm": "반려동물 용품",
        "upCatNo": "004",
        "sortOrd": "99",
        "childList": null
      }
    ]
  },
  {
    "catNo": "005",
    "catNm": "가구/홈/데코",
    "upCatNo": "TOP",
    "sortOrd": "5",
    "childList": [
      {
        "catNo": "005001",
        "catNm": "거실/수납 가구",
        "upCatNo": "005",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "005002",
        "catNm": "서재/사무용 가구",
        "upCatNo": "005",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "005003",
        "catNm": "침실 가구",
        "upCatNo": "005",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "005004",
        "catNm": "인테리어 소품",
        "upCatNo": "005",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "005005",
        "catNm": "침구/리빙",
        "upCatNo": "005",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "005006",
        "catNm": "가구/홈/데코",
        "upCatNo": "005",
        "sortOrd": "99",
        "childList": null
      }
    ]
  },
  {
    "catNo": "006",
    "catNm": "스포츠/자동차",
    "upCatNo": "TOP",
    "sortOrd": "6",
    "childList": [
      {
        "catNo": "006001",
        "catNm": "스포츠 의류",
        "upCatNo": "006",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "006002",
        "catNm": "스포츠 신발",
        "upCatNo": "006",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "006003",
        "catNm": "스포츠 잡화",
        "upCatNo": "006",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "006004",
        "catNm": "스포츠",
        "upCatNo": "006",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "006005",
        "catNm": "자동자 용품",
        "upCatNo": "006",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "006006",
        "catNm": "자동차",
        "upCatNo": "006",
        "sortOrd": "99",
        "childList": null
      }
    ]
  },
  {
    "catNo": "007",
    "catNm": "가전/디지털",
    "upCatNo": "TOP",
    "sortOrd": "7",
    "childList": [
      {
        "catNo": "007001",
        "catNm": "TV/냉장고/세탁기",
        "upCatNo": "007",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "007002",
        "catNm": "에어컨",
        "upCatNo": "007",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "007003",
        "catNm": "노트북/데스크탑",
        "upCatNo": "007",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "007004",
        "catNm": "휴대폰 액세서리",
        "upCatNo": "007",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "007005",
        "catNm": "음향기기",
        "upCatNo": "007",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "007006",
        "catNm": "가전/컴퓨터",
        "upCatNo": "007",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "007007",
        "catNm": "디지털",
        "upCatNo": "007",
        "sortOrd": "99",
        "childList": null
      }
    ]
  },
  {
    "catNo": "008",
    "catNm": "여행/레저/캠핑",
    "upCatNo": "TOP",
    "sortOrd": "8",
    "childList": [
      {
        "catNo": "008001",
        "catNm": "여행상품",
        "upCatNo": "008",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "008002",
        "catNm": "레저용품",
        "upCatNo": "008",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "008003",
        "catNm": "입장권/패스/현지투어",
        "upCatNo": "008",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "008004",
        "catNm": "패키지/자유여행",
        "upCatNo": "008",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "008005",
        "catNm": "캠핑용품",
        "upCatNo": "008",
        "sortOrd": "99",
        "childList": null
      }
    ]
  },
  {
    "catNo": "009",
    "catNm": "지역/컬쳐/쿠폰",
    "upCatNo": "TOP",
    "sortOrd": "9",
    "childList": [
      {
        "catNo": "009001",
        "catNm": "지역/컬쳐",
        "upCatNo": "009",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "009002",
        "catNm": "쿠폰",
        "upCatNo": "009",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "009003",
        "catNm": "공연/전시/체험/키즈",
        "upCatNo": "009",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "009004",
        "catNm": "맛집/뷔페/카페",
        "upCatNo": "009",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "009005",
        "catNm": "뷰티/시술/운동",
        "upCatNo": "009",
        "sortOrd": "99",
        "childList": null
      }
    ]
  },
  {
    "catNo": "010",
    "catNm": "도서/취미",
    "upCatNo": "TOP",
    "sortOrd": "10",
    "childList": [
      {
        "catNo": "010001",
        "catNm": "도서",
        "upCatNo": "010",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "010002",
        "catNm": "문구/사무용품",
        "upCatNo": "010",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "010003",
        "catNm": "DIY/공예",
        "upCatNo": "010",
        "sortOrd": "99",
        "childList": null
      },
      {
        "catNo": "010004",
        "catNm": "교육/취미",
        "upCatNo": "010",
        "sortOrd": "99",
        "childList": null
      }
    ]
  }
];
